import { type AsyncComponentLoader } from 'vue'
import { type GuardConfigType } from 'vue-router'

export function guardComponentForType(
  guardConfigType: GuardConfigType,
): AsyncComponentLoader {
  switch (guardConfigType) {
    case 'tier-guard':
      return () => import('./TierGuard.vue')
    case 'project-guard':
      return () => import('./ProjectGuard.vue')
    case 'mockup-guard':
      return () => import('./MockupGuard.vue')
    case 'palette-guard':
      return () => import('./PaletteGuard.vue')
    case 'feature-guard':
      return () => import('./FeatureGuard.vue')
  }
}
